import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { EvTooltipModule } from "ev-tooltip";
import { NewDwellingStageItemComponent } from "src/app/ev-map/new-dwellings-map/new-dwelling-listings/new-dwellings-list/new-dwelling-stage-item.component";
import { IProjectStageDto } from "src/models/new-dwelling/new-dwelling.model";

@Component({
    selector: "new-dwelling-cluster-popup",
    imports: [NewDwellingStageItemComponent, EvTooltipModule],
    templateUrl: "./new-dwelling-cluster-popup.component.html",
    styleUrl: "./new-dwelling-cluster-popup.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingClusterPopupMarkerComponent {
    readonly data = input<IProjectStageDto[]>();

    protected projects = computed(() =>
        [...(this.data() ?? [])].sort((a, b) => a.projectName.localeCompare(b.projectName, undefined, { sensitivity: "base" })),
    );
}
